import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { List } from 'immutable'

interface PartitionResult<L> {
  yay: L
  nay: L
}

export const partition = <I>(items: List<I>, predicate: (item: I, index?: number) => boolean): [List<I>, List<I>] => {
  const initialResult: PartitionResult<List<I>> = {
    yay: List(),
    nay: List()
  }
  const result = items.reduce((acc, item, index) =>
    predicate(item, index) ? {
      yay: acc.yay.push(item), nay: acc.nay
    } : {
      yay: acc.yay, nay: acc.nay.push(item)
    }
    , initialResult)
  return [result.yay, result.nay]
}

export const slugify: (str: string) => string = (str: string) =>
  str != undefined
    ? str
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '')
    : ''

export const camelize = (text: string) => {
  text = text.replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
  return text.substr(0, 1).toLowerCase() + text.substr(1)
}

export const convertReactNodeToString = (title: React.ReactNode) => {
  if (title === undefined) return ''
  if (typeof title === 'string') return title

  if (typeof title === 'number' || typeof title === 'boolean') {
    return title.toString()
  }

  if (React.isValidElement(title)) {
    let flatTitle: string = ReactDOMServer.renderToStaticMarkup(title)
    flatTitle = flatTitle.replace(/(<([^>]+)>)/gi, '')
    return flatTitle
  }

  return ''
}

export function getClassName<Style>(style: Style, className: keyof Style, notset: string = ''): string {
  return String(style[className] ? style[className] : notset)
}

export const convertRemToPx = (rem: string | number) => {
  const remValue = typeof rem == 'string' ? parseFloat(rem) : rem
  return parseFloat(getComputedStyle(document.documentElement).fontSize) * remValue
}
export const convertPxToRem = (px: number) => px / parseFloat(getComputedStyle(document.documentElement).fontSize)

export const htmlDecode = (input: string) => {
  var doc = new DOMParser().parseFromString(input, 'text/html')
  return doc.documentElement.textContent
}

export const unEntity = (str: string) => str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
